import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";

interface Brand {
  id: number;
  name: string;
  image_url?: string;
}

const BrandsScroll: React.FC = (style: object) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from("brands")
          .select("id, name, image_url")
          .limit(20);

        if (error) throw error;

        // handleImage
        data.forEach((brand: Brand) => {
          if (brand.image_url) {
            brand.image_url = `https://gzvhulvbgyymgjgdalpa.supabase.co/storage/v1/object/public/publicimages/brand-images/${brand.image_url}`;
          }
        });

        if (data && data.length > 0) {
          // Duplicate the brands array to create seamless infinite scroll
          setBrands([...data, ...data, ...data]);
        }
      } catch (err) {
        console.error("Error fetching brands:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  const handleBrandClick = (brandId: number) => {
    navigate(`/products?brand_id=${brandId}`);
  };

  if (loading) {
    return (
      <div className="py-12 bg-neutral-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Popular Brands
            </h2>
            <p className="text-neutral-400">Loading brands...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="py-2 overflow-hidden bg-neutral-900 border-y border-neutral-800"
      style={style}
    >
      {/* Infinite scroll container */}
      <div className="relative overflow-hidden py-8">
        <div className="brands-scroll-track">
          {brands.map((brand, index) => (
            <div
              key={`${brand.id}-${index}`}
              onClick={() => handleBrandClick(brand.id)}
              className="shrink-0 w-45 cursor-pointer transition-transform duration-300 hover:-translate-y-1.25 md:w-37.5"
            >
              <div className="rounded-xl py-8 px-6 transition-all duration-300 flex flex-col items-center justify-center gap-4 min-h-35 hover:bg-primary hover:shadow-[0_8px_24px_rgba(0,0,0,0.12)] md:py-6 md:px-4 md:min-h-30">
                {brand.image_url ? (
                  <div className="flex items-center justify-center w-20 h-15">
                    <img
                      src={brand.image_url}
                      alt={brand.name}
                      className="w-30 h-15 object-contain grayscale transition-all duration-300 hover:grayscale-0 max-w-full max-h-full md:w-15 md:h-11.25"
                    />
                  </div>
                ) : (
                  <div className="w-20 h-15 bg-linear-to-br from-[#667eea] to-[#764ba2] rounded-lg flex items-center justify-center md:w-15 md:h-11.25">
                    <span className="text-[2rem] font-bold text-white md:text-2xl">
                      {brand.name.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
                {/* <h3 className="brand-name">{brand.name}</h3> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export { BrandsScroll };
